import { styled, Grid as GridBase } from "@mui/material";

export const GridContainer = styled((props) => (
  <GridBase {...props} container />
))`
  &.MuiGrid-container {
    margin: ${(props) => props.margin || "0"};
    gap: ${(props) => props.spacing || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;

export const BillingInfoFormRootArea = styled((props) => (
  <GridContainer {...props} />
))``;

export const GridItem = styled((props) => <GridBase {...props} item />)`
  &.MuiGrid-item {
    display: flex;
    flex-direction: ${(props) => props.flexDirection || "column"};
    margin: ${(props) => props.margin || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;
